(function($) {
    class PostLoader {
        constructor(conf) {
            this.state = {
                post_type: conf.post_type || null,
                s: conf.s || null,
                currentoffset: conf.offset || 0,
                posts_per_page: conf.posts_per_page || 0,
                hasmore: true,
                template: conf.template || null,
                cat: conf.cat || null,
                term: conf.term || null,
                tax: conf.tax || null,
                page: null,
                scrollOffset: 0,
                lastsearch: '',
                loadmode: conf.loadmode || null
            }

            this.el = conf.el;

            this.xhr = null;

            this.ui = {
                s: this.el.find('.js-searchinput'),
                sbutton: this.el.find('.searchForm button'),
                more: this.el.find('.js-loadmore'),
                container: this.el.find('.ajaxContainer'),
                pagination: this.el.find('.pagination'),
                template: $('#' + this.state.template),
                pageHeader: $('.pageHeader')
            }

            this.template = _.template(this.ui.template.html());
            this.lastsearch = '';
            this.timer;

            this.init();
        }

        events() {
            let self = this;

            this.ui.more.on('click', e => {
                e.preventDefault();
                this.state.rendertype = 'append';
                if (this.state.page) {
                    this.state.page = this.state.page + 1;
                } else {
                    this.state.page = 2;
                }

                this.doRequest();
            });
        }

        doRequest() {
            const self = this;

            if (this.xhr) {
                console.log('aborting prev');
                this.xhr.abort();
            }

            this._setLoadingState(true);

            this.xhr = $.ajax({
                type: 'GET',
                url: window.ajaxurl,
                data: {
                    action: 'sm_postsloader',
                    payload: self.state
                },
                dataType: 'json',
                success: function(response) {
                    this.xhr = null;
                    self.render(response.posts);
                    self.renderPagination(response.pagination),
                    self.postRequestSetup(response);
                },
                error: function(error) {
                    this.xhr = null;
                    console.log('error');
                }
            });
        }

        renderPagination(code) {
            this.ui.pagination.html(code);
        }

        render(posts) {
            let output = '';
            posts.forEach(post => {
                output += this.template(post);
            });

            if (this.state.rendertype == 'append') {
                this.ui.container.append(output);
            }

            if (this.state.rendertype == 'replace') {
                this.ui.container.html(output)
            }

            // this.ui.s.blur();
        }

        postRequestSetup(data) {
            this._setLoadingState(false);
            this._setMoreState(data.hasmore);
            this.state.currentoffset = data.currentoffset;
            data.posts.length ? this._setNoResults(false) : this._setNoResults(true);
            $(window).trigger('resize');
        }

        _setLoadingState(towhat) {
            this.state.loading = towhat;
            towhat ? this.el.addClass('is-loading') : this.el.removeClass('is-loading');
        }

        _setMoreState(towhat) {
            this.state.hasmore = towhat;
            towhat ? this.el.removeClass('nomore') : this.el.addClass('nomore');
        }

        _setNoResults(towhat) {
            towhat ? this.el.addClass('noresults') : this.el.removeClass('noresults');
        }

        init() {
            console.log(this.state);
            this.events();
        }
    }

    const AMC_POSTSLOADER = {
        init: function() {
            $('.js-postsloader').each(function() {
                let that = $(this);

                let loader = new PostLoader({
                    el: that,
                    post_type: that.data('posttype') || null,
                    s: that.data('s') || null,
                    offset: that.data('offset') || null,
                    posts_per_page: that.data('loadcount') || null,
                    template: that.data('template') || null,
                    loadmode: that.data('loadmode') || null,
                    cat: that.data('cat') || null,
                    term: that.data('term') || null,
                    tax: that.data('tax') || null,
                    page: 1
                });
            });
        }
    }

    $(document).ready(function() {
        AMC_POSTSLOADER.init();
    });
})(jQuery)